import React from 'react';
import { Avatar } from 'antd';
import { useSelector } from 'react-redux';

/**
 * OVO-125 — small square partner-logo avatar, shown next to a partner name
 * everywhere a partner surfaces (Partners list, Orders/Routes tables,
 * PartnerDetail header, GlobalStats comparison). Falls back to the partner's
 * initials when no logo is set.
 *
 * Callers pass `logoKey` (the File.key from whatever projection they have) +
 * `name`; the GCS host comes from the authenticated user. (The PUBLIC tracking
 * page has no Redux store, so it renders its own <img> from `partnerLogoUrl`
 * instead of this component.)
 */
const initials = (name) => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  return (
    parts
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .filter(Boolean)
      .join('') || '?'
  );
};

export default function PartnerLogo({ name, logoKey, size = 22, style }) {
  const host = useSelector((s) => s.auth?.user?.host);
  const src = host && logoKey ? `${host}/${logoKey}` : null;

  if (src) {
    return <Avatar src={src} size={size} shape="square" style={{ flexShrink: 0, ...style }} />;
  }
  return (
    <Avatar
      size={size}
      shape="square"
      style={{
        flexShrink: 0,
        background: '#eef0f2',
        color: '#8a9099',
        fontSize: Math.max(9, Math.round(size * 0.42)),
        fontWeight: 600,
        ...style,
      }}
    >
      {initials(name)}
    </Avatar>
  );
}
